import React, { useEffect, useState } from "react";
import NavigationBarAvatar from "./NavigationBarAvatar";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { atom, useAtomValue, useSetAtom } from "jotai";
import { clientAtom } from "@/utils/atoms/atomClient";
import { Box, Container, Flex, Skeleton } from "@radix-ui/themes";
import useViewportWidth from "@/hooks/useViewportWidth";
import NavigationBarLayoutSmall from "./NavigationBar.layout.small";
import NotificationRender from "./NotificationRender";
import PartnerLogo from "./PartnerLogo";
import { findPartner } from "@/utils/constants/findPartner";

export const headerHeight = atom(0);

export default function NavigationBarUi(props: any) {
  const [openOffcanvas, setOpenOffcanvas] = useState(false);
  const currentUser = useCurrentUserProfile((s) => s.user);
  const currentClient = useAtomValue(clientAtom);
  const headerRef = useSetAtom(headerHeight);

  useEffect(() => {
    let scrollpos = window.scrollY;
    const header = document.querySelector("header");
    const headerHeight = header.offsetHeight;
    headerRef(headerHeight);

    const AddClassOnScroll = () => header.classList.add("header--scrolled");
    const RemoveClassOnScroll = () =>
      header.classList.remove("header--scrolled");

    window.addEventListener("scroll", function () {
      scrollpos = window.scrollY;

      if (scrollpos >= headerHeight) {
        AddClassOnScroll();
      } else {
        RemoveClassOnScroll();
      }
    });
  });

  const isBestGamer = brand.brandValue === "BG";
  const isElgiganten = brand.brandValue === "ELGIGANTEN";

  const isMobile = useViewportWidth(768);

  const hasCurrentClient = currentClient !== "";

  return (
    <>
      {isMobile && (
        <NavigationBarLayoutSmall
          show={openOffcanvas}
          closeWindow={setOpenOffcanvas}
          isAuth={!!currentUser}
          profile={props.profile}
          currentClient={currentClient}
          currentUser={currentUser}
        />
      )}

      {!isMobile && (
        <header className="header">
          <Container
            className="header__container container"
            size="4"
            py="4"
            px="0"
          >
            <Flex justify={hasCurrentClient ? "between" : "end"} align="center">
              {/* {(isElgiganten || isBestGamer) && (
                <Flex align="stretch" height="48px">
                  {findPartner(currentClient) && (
                    <img
                      src={findPartner(currentClient).logo.large}
                      style={{
                        height: "100%",
                        objectFit: "contain",
                        width: "100%",
                      }}
                    />
                  )}
                </Flex>
              )} */}

              <PartnerLogo isMobile={false} currentClient={currentClient} />

              <Flex gap="2" align="center">
                {brand.hasFeature.notifications && (
                  <NotificationRender
                    profile={props.profile}
                    currentUser={props.currentUser}
                  />
                )}
                {props.profile && (
                  <NavigationBarAvatar profile={props.profile} />
                )}
              </Flex>
            </Flex>
          </Container>
        </header>
      )}
    </>
  );
}
